/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostSearchDataItemPrice
 */
export interface PostSearchDataItemPrice {
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    age?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    fareNett?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    markup?: number;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemPrice
     */
    markupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostSearchDataItemPrice
     */
    markupDescription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    fareGross?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    tax?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    totalNett?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchDataItemPrice
     */
    totalGross?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItemPrice
     */
    fareTypes?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostSearchDataItemPrice
     */
    fareBasises?: Array<string> | null;
    /**
     * 
     * @type {Date}
     * @memberof PostSearchDataItemPrice
     */
    oneAirTTL?: Date;
}

export function PostSearchDataItemPriceFromJSON(json: any): PostSearchDataItemPrice {
    return PostSearchDataItemPriceFromJSONTyped(json, false);
}

export function PostSearchDataItemPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchDataItemPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'age': !exists(json, 'age') ? undefined : json['age'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'fareNett': !exists(json, 'fareNett') ? undefined : json['fareNett'],
        'markup': !exists(json, 'markup') ? undefined : json['markup'],
        'markupId': !exists(json, 'markupId') ? undefined : json['markupId'],
        'markupDescription': !exists(json, 'markupDescription') ? undefined : json['markupDescription'],
        'fareGross': !exists(json, 'fareGross') ? undefined : json['fareGross'],
        'tax': !exists(json, 'tax') ? undefined : json['tax'],
        'totalNett': !exists(json, 'totalNett') ? undefined : json['totalNett'],
        'totalGross': !exists(json, 'totalGross') ? undefined : json['totalGross'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : json['fareTypes'],
        'fareBasises': !exists(json, 'fareBasises') ? undefined : json['fareBasises'],
        'oneAirTTL': !exists(json, 'oneAirTTL') ? undefined : (new Date(json['oneAirTTL'])),
    };
}

export function PostSearchDataItemPriceToJSON(value?: PostSearchDataItemPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'age': value.age,
        'quantity': value.quantity,
        'fareNett': value.fareNett,
        'markup': value.markup,
        'markupId': value.markupId,
        'markupDescription': value.markupDescription,
        'fareGross': value.fareGross,
        'tax': value.tax,
        'totalNett': value.totalNett,
        'totalGross': value.totalGross,
        'fareTypes': value.fareTypes,
        'fareBasises': value.fareBasises,
        'oneAirTTL': value.oneAirTTL === undefined ? undefined : (value.oneAirTTL.toISOString()),
    };
}


